export default __webpack_public_path__ + "static/media/add.ba129403.svg";